export const SITE_ORIGIN = "https://plomberieexcellence.com";
export const BUSINESS_ID = `${SITE_ORIGIN}/#plomberie-excellence`;
export const BUSINESS_NAME = "Plomberie Excellence de Longueuil";
const BUSINESS_SHORT_NAME = "Plomberie Excellence";
export const BUSINESS_PHONE = "+14389081143";
export const BUSINESS_PHONE_DISPLAY = "(438) 908-1143";
export const BUSINESS_HOURS_LABEL = "Ouvert jour et nuit";
export const BUSINESS_MAP_URL = "https://www.google.com/maps?cid=1319153008239034947";

export const businessAddress = {
  "@type": "PostalAddress",
  streetAddress: "1494 Ch. de Chambly",
  addressLocality: "Longueuil",
  addressRegion: "QC",
  postalCode: "J4J 3X3",
  addressCountry: "CA",
} as const;

export const BUSINESS_ADDRESS_LABEL = `${businessAddress.streetAddress}, ${businessAddress.addressLocality}, ${businessAddress.addressRegion} ${businessAddress.postalCode}`;

const servedCities = [
  "Longueuil",
  "Vieux-Longueuil",
  "Saint-Hubert",
  "Greenfield Park",
  "Saint-Lambert",
];

export function createServedArea(name: string) {
  if (["Vieux-Longueuil", "Saint-Hubert", "Greenfield Park"].includes(name)) {
    return {
      "@type": "AdministrativeArea",
      name,
      containedInPlace: { "@type": "City", name: "Longueuil" },
    };
  }

  return { "@type": name === "Rive-Sud" ? "AdministrativeArea" : "City", name };
}

export function canonicalPath(path: string) {
  if (!path.startsWith("/") || path.startsWith("//") || path === "/") {
    return path;
  }

  const match = path.match(/^([^?#]*)(.*)$/);
  const pathname = match?.[1] ?? path;
  const suffix = match?.[2] ?? "";
  const lastSegment = pathname.split("/").filter(Boolean).at(-1) ?? "";

  // Keep links to files such as /sitemap.xml and /opengraph.jpg unchanged.
  if (lastSegment.includes(".")) {
    return path;
  }

  return `${pathname.replace(/\/+$/, "")}/${suffix}`;
}

export function siteUrl(path = "/") {
  return `${SITE_ORIGIN}${canonicalPath(path)}`;
}

export const businessSchema = {
  "@context": "https://schema.org",
  "@type": "Plumber",
  "@id": BUSINESS_ID,
  name: BUSINESS_NAME,
  alternateName: BUSINESS_SHORT_NAME,
  url: siteUrl("/"),
  telephone: BUSINESS_PHONE,
  image: siteUrl("/opengraph.jpg"),
  address: businessAddress,
  description:
    "Entreprise de plomberie basée à Longueuil, au service du Vieux-Longueuil, de Saint-Hubert et de Greenfield Park. Urgences 24/7, débouchage, chauffe-eau et fuites. Interventions aussi dans les villes voisines de la Rive-Sud.",
  areaServed: servedCities.map(createServedArea),
  openingHoursSpecification: {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ],
    opens: "00:00",
    closes: "23:59",
  },
  priceRange: "$$",
} as const;

export function createServiceSchema({
  name,
  description,
  path,
  areaServed,
}: {
  name: string;
  description: string;
  path: string;
  areaServed: string[];
}) {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    name,
    serviceType: name,
    description,
    url: siteUrl(path),
    provider: {
      "@id": BUSINESS_ID,
      "@type": "Plumber",
      name: BUSINESS_NAME,
      alternateName: BUSINESS_SHORT_NAME,
      url: siteUrl("/"),
      telephone: BUSINESS_PHONE,
      address: businessAddress,
      openingHoursSpecification: businessSchema.openingHoursSpecification,
    },
    areaServed: areaServed.map(createServedArea),
  };
}